export const goBackAfterDelete = (history) => {
  const url = window.location.pathname;
  history.push(url.substring(0, url.indexOf('/', 1)));
};

export const isChromeBrowser = navigator.userAgent.indexOf('Chrome') > -1;
export const isWinPlatform = navigator.platform.indexOf('Win') > -1;
export const testRegex = (pattern, toTest = '') => pattern?.test(toTest);

export default {
  goBackAfterDelete,
  isChromeBrowser,
  isWinPlatform,
  testRegex,
};

// function to divide array into chunks for kpi component
export const divideArray = (arr) => {
  const result = [];
  for (let i = 0; i < arr.length; i += 3) {
    result.push(arr.slice(i, i + 3));
  }
  return result;
};
